import { useState, cloneElement } from "react";
import { createPortal } from "react-dom";
import tinycolor from "tinycolor2";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "shards-react";
import { useTheme } from "../Theming/ThemingProvider";
import "./HpModal.css";

const HpModal = ({
  Action,
  open: openProp,
  toggle: toggleProp,
  title,
  body,
  actions,
  colorBackground,
  size,
  className = "",
  bodyClassName = "",
  footerClassName = "",
}) => {
  const { theme } = useTheme();
  const { primaryColor, secondaryColor } = theme;

  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = openProp !== undefined;
  const open = isControlled ? openProp : internalOpen;
  const toggle = isControlled ? toggleProp : () => setInternalOpen((p) => !p);

  const bgColor = colorBackground
    ? tinycolor(primaryColor).getLuminance() >
      tinycolor(secondaryColor).getLuminance()
      ? primaryColor
      : secondaryColor
    : undefined;
  const bgStyle = bgColor ? { backgroundColor: bgColor } : undefined;

  const modal = createPortal(
    <Modal
      open={open}
      toggle={toggle}
      centered
      size={size === "xl" ? undefined : size}
      className={`hp-modal${size ? ` hp-modal-${size}` : ""} ${className}`.trim()}
      backdropClassName="hp-modal-backdrop"
    >
      <ModalHeader
        tag="h2"
        toggle={toggle}
        className="hp-modal-header"
        style={bgStyle}
      >
        {title}
      </ModalHeader>
      <ModalBody
        className={`hp-modal-body ${bodyClassName}`.trim()}
        style={bgStyle}
      >
        {typeof body === "function" ? body(toggle) : body}
      </ModalBody>
      {actions && (
        <ModalFooter
          className={`hp-modal-footer ${footerClassName}`.trim()}
          style={bgStyle}
        >
          {typeof actions === "function" ? actions(toggle) : actions}
        </ModalFooter>
      )}
    </Modal>,
    document.body,
  );

  if (isControlled) {
    return modal;
  }

  return (
    <div onClick={(e) => e.stopPropagation()}>
      {Action && cloneElement(Action, { onClick: () => setInternalOpen(true) })}
      {modal}
    </div>
  );
};

export default HpModal;
